import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Starting in PostHog, you can add the PostHog Slack app to your workspace in `}<a parentName="p" {...{
        "href": "https://app.posthog.com/settings/project#integration-slack"
      }}>{`your project settings`}</a>{`.`}</p>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/allow_slack_bb68272218.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/allow_slack_bb68272218.png" classes="rounded" alt="Allow PostHog Slack app permissions" mdxType="ProductScreenshot" />
    <p>{`The PostHog Slack app will require some basic permissions which you can grant by clicking the `}<strong parentName="p">{`Allow`}</strong>{` button.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      